module.exports = __webpack_public_path__ + "static/media/scooter_bag.2813a9fe.svg";